export default __webpack_public_path__ + "static/media/Catalog.25208245.png";